import { httpInstance } from '@/services/httpInstance';

const getCommissionsService = async () => {
  let res;
  const endpoint = '/back-office/v1/commissions/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getCommissionsService;
